import React, {Component} from 'react';
import { config } from '../Constants'

const imgSucesso = config.url.CONTEXT+"assets/layout/images/sucess.png";

export class LocalizacaoEnviada extends Component {

    render() {
        return (
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-grid">
                            <div className="p-col-12">
                                <div className="" style={{"textAlign": "center"}}>
                                       <p><b>Localização confirmada com sucesso!</b></p>
                                </div>
                            </div>
                        </div>
                        <div className="p-grid">
                            <div className="p-col-4">
                                <div className="">
                                </div>
                            </div>
                            <div className="p-col-4">
                                <div className="">
                                    <img src={imgSucesso} width="100%" alt=""/>
                                </div>
                            </div>
                            <div className="p-col-4">
                                <div className="">
                                </div>
                            </div>
                        </div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                <div className="" style={{"textAlign": "center"}}>
                                       <p></p>
                                </div>
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
        );
    }
}